{
    "warning": "CẢNH BÁO!",
    "message": "Đừng nhập hay dán mã mà bạn không hiểu rõ.\nNếu bạn sử dụng console này, những kẻ tấn công có thể mạo nhận bạn, rồi đánh cắp thông tin của bạn bằng cách sử dụng phương pháp tấn công Self-XSS."
}
